export {default as styles} from './style.module.scss'